<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { alpha } from "@/helpers/helper";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import { revenueChart } from "./data-profile";
import { mapState } from "vuex";

import { mapActions } from "vuex";
import Vue from "vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { countries } from "../../../components/CountryCode";
import Multiselect from "vue-multiselect";
//import Stat from "@/components/widgets/stat";

import {
  required,
  requiredIf,
  minLength,
  maxLength,
  sameAs,
  numeric,
} from "vuelidate/lib/validators";

Vue.component("vue-phone-number-input", VuePhoneNumberInput);
/**
 * Contacts-Profile component
 */
export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DropzonePopup, Multiselect },
  data() {
    return {
      currentUser: {
        id: "",
        name: "",
        email: "",
        phone_number: "",
        about: "",
        address: "",
        website: "",
        ticker: "",
        short_about: "",
        image: "",
        edit_image: "",
        role: "",
        plan_name: "",
      },
      user_images: "",
      role: "",
      tickerSeen: false,
      profile_media_paths: "",
      passwordInfo: {
        current_password: "",
        new_password: "",
        confirm_password: "",
      },
      color: {
        "text-danger": true,
      },
      revenueChart: revenueChart,
      title: "Profile",
      countries: countries,
    };
  },
  validations: {
    currentUser: {
      name: {
        required,
        // required: requiredIf(function (currentUser) {
        //     return currentUser.role == 'Admin'
        // }),
        minLength: minLength(3),
        maxLength: maxLength(40),
        alpha,
      },
      ticker: {
        required: requiredIf(function () {
          return this.currentUser.plan_name === "Company Investor Relations Account";
        }),
      },
      phone_number: {
        numeric,
        minLength: minLength(10),
      },
      about: {
        minLength: minLength(3),
        maxLength: maxLength(8000),
      },
      short_about: {
        minLength: minLength(3),
        maxLength: maxLength(250),
      },
      address: {
        minLength: minLength(3),
        maxLength: maxLength(8000),
      },
    },
    passwordInfo: {
      current_password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20),
      },
      new_password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20),
      },
      confirm_password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20),
        sameAsPassword: sameAs("new_password"),
      },
    },
  },

  computed: {
    ...mapState("authfack", ["user", "profile_media_path", "user_image"]),
    user() {
      return this.$store ? this.$store.state.authfack.user : null;
    },
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    user_image() {
      return this.$store ? this.$store.state.authfack.user_image : null;
    },
    user_image_delete_url() {
      return this.user.role === "Owner"
        ? process.env.VUE_APP_MIX_URL + "/company/company-delete-user-by-name"
        : process.env.VUE_APP_MIX_URL + "/admin/admin-delete-user-by-name";
    },
    // profile_media_path()
  },
  //  watch: {
  //     '$store.state.authfack.user_image': {
  //         //immediate: true,
  //         handler() {
  //             console.log('tttt');
  //             this.$store.state.authfack.user_image =  this.user.image
  //           //  this.profile_media_paths =  this.user.profile_media_path
  //         }
  //     }

  // },

  mounted() {
    console.log("this.user", this.user);
    this.currentUser.id = this.user.id;
    this.currentUser.name = this.user.name;
    this.currentUser.email = this.user.email;
    this.currentUser.role = this.user.role;
    (this.currentUser.country_code = this.countries.find(
      (c) => c.value == this.user.country_code
    )),
      (this.currentUser.role_id = this.user.role_id);
    this.currentUser.phone_number = this.user.phone_number;
    this.currentUser.about = this.user.description;
    this.currentUser.short_about = this.user.short_description;
    this.currentUser.ticker = this.user.ticker == "" ? "" : this.user.ticker;
    this.currentUser.address = this.user.address;
    this.currentUser.edit_image = this.user.image;
    this.currentUser.website = this.user.website;
    this.currentUser.plan_name = this.user.plan_name;
    this.role = this.user.role;

    if (this.currentUser.plan_name == "Company Investor Relations Account") {
      this.tickerSeen = true;
    } else {
      this.tickerSeen = false;
    }
    //this.$store.state.authfack.user_image = this.user.image
    // this.$store.state.authfack.profile_media_path = this.user.profile_media_path
    // this.user_images = this.user.imagewindow.axios.defaults.headers.common["Authorization
    // this.profile_media_paths = this.user.profile_media_path
    //this.user_images = {...this.user_image}
  },

  methods: {
    ...mapActions("authfack", [
      "updateProfileDetails",
      "updatePasswordDetails",
      "updateUser",
    ]),

    onUserImagedeleted() {
      this.updateUser({ image: "" });
      let user_temp = JSON.parse(localStorage.getItem("user"));
      user_temp.image = "";
      localStorage.setItem("user", JSON.stringify(user_temp));
      this.currentUser.edit_image = "";
    },

    // update profile details
    updateProfileInfo() {
      console.log("this.currentUser.ticker", this.currentUser.ticker);
      this.$v.currentUser.$touch();
      if (this.$v.currentUser.$invalid) {
        return;
      } else {
        console.log("this.currentUser.country_code", this.currentUser);
        if (this.currentUser.role_id == 2) {
          let userData = {
            name: this.currentUser.name,
            role: this.currentUser.role,
            user_id: this.currentUser.id,
            email: this.currentUser.email,
            country_code: this.currentUser.country_code.value,
            phone_number: this.currentUser.phone_number,
            website: this.currentUser.website,
            about: this.currentUser.about,
            short_about: this.currentUser.short_about,
            address: this.currentUser.address,
            ticker: this.currentUser.ticker,
            image: this.currentUser.image,
            edit_image: this.currentUser.edit_image,
            is_active: 1,
          };
          console.log("dsfsdfsdf", userData);
          this.updateProfileDetails(userData).then((res) => {
            if (res == true) {
              this.$router.push({ name: "company.dashboard" });
            }
          });
        } else {
          let userData = {
            name: this.currentUser.name,
            role: this.currentUser.role,
            user_id: this.currentUser.id,
            email: this.currentUser.email,
            image: this.currentUser.image,
            edit_image: this.currentUser.edit_image,
            is_active: 1,
          };

          console.log("dsfsdfsdf", userData);
          this.updateProfileDetails(userData).then((res) => {
            if (res == true) {
              this.$router.push({ name: "default" });
            }
          });
        }
      }
    },

    // change password
    updatePasswordInfo() {
      this.$v.passwordInfo.$touch();
      if (this.$v.passwordInfo.$invalid) {
        return;
      } else {
        let passwordData = {
          current_password: this.passwordInfo.current_password,
          new_password: this.passwordInfo.new_password,
          user_id: this.currentUser.id,
          role: this.currentUser.role,
        };
        this.updatePasswordDetails(passwordData);
      }
    },

    // reset form on cancel button
    resetForm(type) {
      if (type === "profile") {
        // this.$v.user.$reset();
        if (this.currentUser.role_id == 2) {
          this.$router.push({ name: "company.dashboard" });
        } else {
          this.$router.push({ name: "default" });
        }
      }
      if (type === "password") {
        if (this.currentUser.role_id == 2) {
          this.$router.push({ name: "company.dashboard" });
        } else {
          this.$router.push({ name: "default" });
        }
        //  this.$v.passwordInfo.$reset();
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted" lazy>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("profileUpdate.profileDetail")
                  }}</span>
                </template>
                <div class="col-md-6">
                  <div v-if="notification.message" :class="'alert ' + notification.type">
                    {{ notification.message }}
                  </div>
                  <form method="POST" action="#" @submit.prevent="updateProfileInfo">
                    <div class="row">
                      <div class="col-6" v-if="tickerSeen">
                        <div class="form-group mb-3" v-if="currentUser.role == 'Owner'">
                          <label class="control-label"
                            >{{ $t("userManagement.profile.ticker") }}
                            <span :class="color">*</span></label
                          >
                          <input
                            v-model="currentUser.ticker"
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': $v.currentUser.ticker.$error }"
                            :placeholder="$t('userManagement.profile.tickerPlaceholder')"
                          />
                          <div
                            v-if="$v.currentUser.ticker.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.currentUser.ticker.required">{{
                              $t("Please enter ticker")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label class="control-label">{{
                            $t("userManagement.profile.email")
                          }}</label>
                          <input
                            class="form-control"
                            type="email"
                            v-model="currentUser.email"
                            readonly
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label class="control-label"
                            >{{ $t("userManagement.profile.firstName")
                            }}<span :class="color">*</span></label
                          >
                          <input
                            v-model="currentUser.name"
                            type="text"
                            class="form-control"
                            maxlength="70"
                            :class="{ 'is-invalid': $v.currentUser.name.$error }"
                          />
                          <div v-if="$v.currentUser.name.$error" class="invalid-feedback">
                            <span v-if="!$v.currentUser.name.required">{{
                              $t("userManagement.profile.firstError")
                            }}</span>
                          </div>
                          <div v-if="$v.currentUser.name.$error" class="invalid-feedback">
                            <span v-if="!$v.currentUser.name.minLength">{{
                              $t("userManagement.profile.nameMinlengthError")
                            }}</span>
                          </div>
                          <div v-if="$v.currentUser.name.$error" class="invalid-feedback">
                            <span v-if="!$v.currentUser.name.maxLength">{{
                              $t("userManagement.profile.namemaxlengthError")
                            }}</span>
                          </div>
                          <div v-if="$v.currentUser.name.$error" class="invalid-feedback">
                            <span v-if="!$v.currentUser.name.alpha">{{
                              $t("Enter only alphabet")
                            }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="form-group" v-if="currentUser.role == 'Owner'">
                          <label class="control-label">{{
                            $t("userManagement.profile.phoneNumber")
                          }}</label>
                          <div style="display: flex">
                            <div class="input-group-prepend" style="width: 90px">
                              <multiselect
                                v-model="currentUser.country_code"
                                :options="countries"
                                :searchable="true"
                                track-by="label"
                                label="value"
                                :taggable="true"
                                name="country_code"
                                :clearable="false"
                                placeholder="Code"
                                :clearOnSelect="false"
                                :allowEmpty="false"
                              >
                                <template
                                  v-slot:tag="{ option, handleTagRemove, disabled }"
                                >
                                  <div class="multiselect-tag is-user">
                                    <span>{{ option.value }}</span>
                                    <i
                                      v-if="!disabled"
                                      @click.prevent
                                      @mousedown.prevent.stop="
                                        handleTagRemove(option, $event)
                                      "
                                    />
                                  </div>
                                </template>
                                <template v-slot:option="{ option }">
                                  {{ option.label }} ({{ option.value }})
                                </template>
                              </multiselect>
                            </div>
                            <input
                              v-model="currentUser.phone_number"
                              type="text"
                              :placeholder="
                                $t('userManagement.profile.phoneNumberPlaceholder')
                              "
                              class="form-control"
                              :class="{
                                'is-invalid': $v.currentUser.phone_number.$error,
                              }"
                            />

                            <div
                              v-if="$v.currentUser.phone_number.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.currentUser.phone_number.minLength">{{
                                $t("register.phoneMinlengthError")
                              }}</span>
                            </div>
                            <div
                              v-if="$v.currentUser.phone_number.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.currentUser.phone_number.numeric">{{
                                $t("register.phoneNumericError")
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3" v-if="currentUser.role == 'Owner'">
                          <label class="control-label">{{
                            $t("userManagement.profile.website")
                          }}</label>
                          <input
                            v-model="currentUser.website"
                            type="text"
                            class="form-control"
                            :placeholder="$t('userManagement.profile.websitePlaceholder')"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3" v-if="currentUser.role == 'Owner'">
                          <label class="control-label">{{
                            $t("userManagement.profile.short_about")
                          }}</label>
                          <textarea
                            class="form-control"
                            :placeholder="
                              $t('userManagement.profile.shortaboutPlaceholder')
                            "
                            v-model="currentUser.short_about"
                            :class="{ 'is-invalid': $v.currentUser.short_about.$error }"
                          ></textarea>

                          <div
                            v-if="$v.currentUser.short_about.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.currentUser.short_about.minLength">{{
                              $t("userManagement.profile.shortaboutMinlengthError")
                            }}</span>
                          </div>
                          <div
                            v-if="$v.currentUser.short_about.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.currentUser.short_about.maxLength">{{
                              $t("userManagement.profile.shortaboutMaxLength")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3" v-if="currentUser.role == 'Owner'">
                          <label class="control-label">{{
                            $t("userManagement.profile.about")
                          }}</label>
                          <textarea
                            class="form-control"
                            :placeholder="$t('userManagement.profile.aboutPlaceholder')"
                            v-model="currentUser.about"
                            :class="{ 'is-invalid': $v.currentUser.about.$error }"
                          ></textarea>

                          <div
                            v-if="$v.currentUser.about.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.currentUser.about.minLength">{{
                              $t("userManagement.profile.aboutMinlengthError")
                            }}</span>
                          </div>
                          <div
                            v-if="$v.currentUser.about.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.currentUser.about.maxLength">{{
                              $t("userManagement.profile.aboutMaxLength")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3" v-if="currentUser.role == 'Owner'">
                          <label class="control-label">{{
                            $t("userManagement.profile.address")
                          }}</label>
                          <textarea
                            class="form-control"
                            :placeholder="$t('userManagement.profile.addressPlaceholder')"
                            v-model="currentUser.address"
                            :class="{ 'is-invalid': $v.currentUser.address.$error }"
                          ></textarea>

                          <div
                            v-if="$v.currentUser.address.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.currentUser.address.minLength">{{
                              $t("userManagement.profile.addressMinlengthError")
                            }}</span>
                          </div>
                          <div
                            v-if="$v.currentUser.address.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.currentUser.address.maxLength">{{
                              $t("userManagement.profile.addressMaxLength")
                            }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label class="control-label">{{
                            $t("userManagement.profile.profileImage")
                          }}</label>
                          <!-- <dropzone-popup
                                                  v-model="user.profile_photo"
                                                  id="user_image"
                                                  name="user_image"
                                                  acceptedFiles=".jpeg,.jpg,.png"
                                                  :editable-images="user_image"
                                                  :media-path="profile_media_path+'/original'"
                                                  :delete-path="user_image_delete_url"
                                                  :sas-token="sas_token"
                                                  @image-deleted="this.onUserImagedeleted"
                                              /> -->
                          <dropzone-popup
                            v-model="currentUser.image"
                            id="image"
                            name="image"
                            acceptedFiles=".jpeg,.jpg,.png"
                            :editableImages="currentUser.edit_image"
                            :media-path="user.profile_media_path + '/original'"
                            :delete-path="user_image_delete_url"
                            :editImage="true"
                            @image-deleted="this.onUserImagedeleted"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <button type="submit" class="btn btn-primary">
                        {{ $t("commonText.update") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary ml-3"
                        @click="resetForm('profile')"
                      >
                        {{ $t("commonText.cancel") }}
                      </button>
                    </div>
                  </form>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("profileUpdate.changePassword")
                  }}</span>
                </template>
                <div class="col-md-6">
                  <div v-if="notification.message" :class="'alert ' + notification.type">
                    {{ notification.message }}
                  </div>
                  <form method="POST" action="#" @submit.prevent="updatePasswordInfo">
                    <div class="form-group mb-3">
                      <label class="control-label"
                        >{{ $t("profileUpdate.currentPassword")
                        }}<span :class="color">*</span></label
                      >
                      <input
                        v-model="passwordInfo.current_password"
                        type="password"
                        class="form-control"
                        maxlength="20"
                        :class="{ 'is-invalid': $v.passwordInfo.current_password.$error }"
                      />
                      <div
                        v-if="$v.passwordInfo.current_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.current_password.required">{{
                          $t("profileUpdate.currentPasswordError")
                        }}</span>
                      </div>
                      <div
                        v-if="$v.passwordInfo.current_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.current_password.minLength">{{
                          $t("profileUpdate.currentPasswordErrorMin")
                        }}</span>
                      </div>
                      <div
                        v-if="$v.passwordInfo.current_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.current_password.maxLength">{{
                          $t("profileUpdate.currentPasswordErrorMax")
                        }}</span>
                      </div>
                    </div>

                    <div class="form-group mb-3">
                      <label class="control-label"
                        >{{ $t("profileUpdate.newPassword")
                        }}<span :class="color">*</span></label
                      >
                      <input
                        v-model="passwordInfo.new_password"
                        type="password"
                        class="form-control"
                        maxlength="20"
                        :class="{ 'is-invalid': $v.passwordInfo.new_password.$error }"
                      />
                      <div
                        v-if="$v.passwordInfo.new_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.new_password.required">{{
                          $t("profileUpdate.newPasswordError")
                        }}</span>
                      </div>
                      <div
                        v-if="$v.passwordInfo.new_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.new_password.minLength">{{
                          $t("profileUpdate.newPasswordMin")
                        }}</span>
                      </div>
                      <div
                        v-if="$v.passwordInfo.new_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.new_password.maxLength">{{
                          $t("profileUpdate.newPasswordMax")
                        }}</span>
                      </div>
                    </div>

                    <div class="form-group mb-3">
                      <label class="control-label"
                        >{{ $t("profileUpdate.confirmNewPassword")
                        }}<span :class="color">*</span></label
                      >
                      <input
                        v-model="passwordInfo.confirm_password"
                        type="password"
                        class="form-control"
                        maxlength="20"
                        :class="{ 'is-invalid': $v.passwordInfo.confirm_password.$error }"
                      />
                      <div
                        v-if="$v.passwordInfo.confirm_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.confirm_password.required">{{
                          $t("profileUpdate.confirmNewPasswordError")
                        }}</span>
                      </div>
                      <div
                        v-if="$v.passwordInfo.confirm_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.confirm_password.minLength">{{
                          $t("profileUpdate.confirmNewPasswordMin")
                        }}</span>
                      </div>
                      <div
                        v-if="$v.passwordInfo.confirm_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.confirm_password.maxLength">{{
                          $t("profileUpdate.confirmNewPasswordMax")
                        }}</span>
                      </div>
                      <div
                        v-if="$v.passwordInfo.confirm_password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.passwordInfo.confirm_password.sameAsPassword">{{
                          $t("profileUpdate.confirmNewPasswordSame")
                        }}</span>
                      </div>
                    </div>

                    <div class="form-group mb-3">
                      <button type="submit" class="btn btn-primary">
                        {{ $t("commonText.update") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary ml-3"
                        @click="resetForm('password')"
                      >
                        {{ $t("commonText.cancel") }}
                      </button>
                    </div>
                  </form>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
